import './index.css'
import './sentry'
import './i18n'
import React, { Suspense } from 'react'

import App from './App'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { LoadingBolt } from './components/LoadingBolt'
import { persistSessionParameters } from './helpers/urls'
import * as Sentry from '@sentry/react'
import { skipPreMeeting, skipPermissions } from './helpers/globalFunctions'
import { BrowserRouter } from 'react-router-dom'
import { initGoogleAnalytics } from './lib/analytics'

if (typeof window !== 'undefined') {
    window.eggFunctions = {
        skipPreMeeting,
        skipPermissions,
    }
}

persistSessionParameters()
initGoogleAnalytics()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <Suspense fallback={<LoadingBolt />}>
        <React.StrictMode>
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <App />
            </BrowserRouter>
        </React.StrictMode>
    </Suspense>
)

reportWebVitals()
